export default __webpack_public_path__ + "static/media/acceleX.b806a206.svg";